<template>
  <kst-section collapsible collapsed info-mode
    :title="sectionTitle"
    :help-collapsed="sectionHelpCollapsed"
    :help-expanded="sectionHelpExpanded"
  >
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="userData"
      dateField="ReceiveDate"
      numberField="ReceiveID"
    />
  </kst-section>
</template>

<script>
import Catalog from "../RrcvCatalog.js";
import Info from "../RrcvInfo.js";
import Model from "../RrcvModel.js";

export default {
  props: {
    userData: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionHelpCollapsed() {
      return Model.getReceiveSectionHelp(this.userData);
    },
    sectionTitle() {
      return Info.Section.Receive.Title;
    },
    sectionHelpExpanded() {
      return Info.Message.Edit_ReceiveFields;
    }
  }
}
</script>